import { render, staticRenderFns } from "./PageTrash.vue?vue&type=template&id=5d2456f6&scoped=true"
import script from "./PageTrash.vue?vue&type=script&lang=js"
export * from "./PageTrash.vue?vue&type=script&lang=js"
import style0 from "./PageTrash.vue?vue&type=style&index=0&id=5d2456f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2456f6",
  null
  
)

export default component.exports